import { useState } from 'react'
import { shrinkPhotoForEmail } from '../utils/shrinkPhoto'
import { outboundAttachmentLimitError } from '../../../shared/ticketAttachmentLimits.js'

/**
 * State for the photos staff attach to an outbound customer email. Each pick
 * is shrunk for email, then added only if the whole set still fits the limits
 * the server enforces. Used by the deal and order email popups.
 */
export function useOutboundPhotos() {
  const [files, setFiles] = useState([])
  const [error, setError] = useState(null)
  const [preparing, setPreparing] = useState(false)

  async function addFromInput(event) {
    const picked = Array.from(event.target.files || [])
    event.target.value = '' // so the same file can be picked again after a remove
    if (picked.length === 0) return

    setPreparing(true)
    setError(null)
    try {
      const shrunk = await Promise.all(picked.map(shrinkPhotoForEmail))
      const next = [...files, ...shrunk]
      const limitError = outboundAttachmentLimitError(next)
      if (limitError) {
        setError(limitError)
        return
      }
      setFiles(next)
    } catch (err) {
      setError(err.message)
    } finally {
      setPreparing(false)
    }
  }

  function removeAt(index) {
    setFiles(current => current.filter((_, i) => i !== index))
  }

  function reset() {
    setFiles([])
    setError(null)
  }

  return { files, error, preparing, addFromInput, removeAt, reset }
}
